import React, { useState } from "react";
import {Link,useNavigate, useSearchParams} from "react-router-dom";

export function ActivoRegistro(){
    const navigate = useNavigate();
    const[params] = useSearchParams();
    const idactivo = params.get('idactivo')?? '';
    const accion = params.get('accion')?? '';
    
    //propiedades
    const[codigo,setCodigo] = useState(params.get('codigo') ?? '');
    const[tipo,setTipo] = useState(params.get('tipo')??''); 
    const[ubicacion,setUbicacion] = useState("");
    const[descripcion,setDescripcion] = useState("");
    const[isSubmitting, setIsSubmitting] = useState(false);
    const[mensaje, setMensaje] = useState({tipo: "", texto: ""});

    const onCodigoChange = e => setCodigo(e.target.value);
    const onTipoChange = e => setTipo(e.target.value);
    const onUbicacionChange = e => setUbicacion(e.target.value);
    const onDescripcionChange = e => setDescripcion(e.target.value);

    const handleGuardarActivo = e =>{
        e.preventDefault();
        setIsSubmitting(true);
        setMensaje({tipo: "", texto: ""});

        const data = {idactivo,codigo,ubicacion,tipo,descripcion};
        console.log(data);
        
            const requestOptions = {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(data)
            };
            fetch(process.env.REACT_APP_INVENTARIO_API_URL+ "api/etiqueta/update/"+idactivo,requestOptions)
            .then(response => response.json())
            .then(res =>{
                console.log(res);
                setIsSubmitting(false);
                if(res.idetiqueta>0){
                    setMensaje({tipo: "success", texto: "Activo registrado correctamente"});
                    setTimeout(() => {
                        navigate('/activo/?idactivo='+idactivo+'&tipo='+tipo+'&codigo='+codigo);
                    }, 1500);
                } else {
                    setMensaje({tipo: "danger", texto: "Error al registrar el activo. Intente nuevamente."});
                }
            })
            .catch(error => {
                console.error("Error:", error);
                setIsSubmitting(false);
                setMensaje({tipo: "danger", texto: "Error de conexión. Intente nuevamente."});
            });
        
    }

    return(
        <div className="container ActivoRegistro py-4">
            <div className="card shadow-sm">
                <div className="card-header bg-primary text-white">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="mb-0">Registro de Activo</h3>
                        <Link to={`/activo/?idactivo=${idactivo}&tipo=${tipo}&codigo=${codigo}`} className="btn btn-light btn-sm">
                            <i className="bi bi-arrow-left me-1"></i> Regresar
                        </Link>
                    </div>
                </div>
                
                <div className="card-body p-4">
                    <div className="alert alert-info mb-4">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-info-circle-fill me-2 fs-4"></i>
                            <div>
                                <h5 className="mb-1">ID del Activo: {idactivo}</h5>
                                <p className="mb-0">Complete la información para registrar este activo en el sistema.</p>
                            </div>
                        </div>
                    </div>
                    
                    {mensaje.tipo && (
                        <div className={`alert alert-${mensaje.tipo} alert-dismissible fade show`} role="alert">
                            {mensaje.tipo === "success" ? (
                                <i className="bi bi-check-circle-fill me-2"></i>
                            ) : (
                                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            )}
                            {mensaje.texto}
                            <button type="button" className="btn-close" onClick={() => setMensaje({tipo: "", texto: ""})}></button>
                        </div>
                    )}
                    
                    <form className="needs-validation was-validated">
                        <div className="row g-3">
                            <div className="col-md-5">
                                <label className="form-label fw-bold">Código</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><i className="bi bi-upc-scan"></i></span>
                                    <input 
                                        className="form-control" 
                                        placeholder="Ingrese el código" 
                                        value={codigo} 
                                        onChange={onCodigoChange} 
                                        required
                                    />
                                    <div className="invalid-feedback">Por favor ingrese un código válido.</div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-bold">Ubicación</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><i className="bi bi-geo-alt"></i></span>
                                    <input 
                                        className="form-control" 
                                        placeholder="Ingrese la ubicación" 
                                        value={ubicacion} 
                                        onChange={onUbicacionChange} 
                                        required
                                    />
                                    <div className="invalid-feedback">Por favor ingrese una ubicación.</div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <label className="form-label fw-bold">Tipo</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><i className="bi bi-tag"></i></span>
                                     
                                    <select className="form-select" value={tipo} onChange={onTipoChange} required>
                                        <option value="">Seleccione...</option>
                                        <option value="flota">Flota</option>
                                        <option value="general">General</option>
                                    </select>

                                    <div className="invalid-feedback">Por favor ingrese un tipo.</div>
                                </div>
                            </div>
                            
                            <div className="col-12">
                                <label className="form-label fw-bold">Descripción</label>
                                <div className="input-group mb-3">
                                    <span className="input-group-text"><i className="bi bi-card-text"></i></span>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Descripción detallada del activo" 
                                        value={descripcion} 
                                        onChange={onDescripcionChange} 
                                        required
                                    />
                                    <div className="invalid-feedback">Por favor ingrese una descripción.</div>
                                </div>
                            </div>
                        </div>

                        <div className="d-grid gap-2 col-md-6 mx-auto mt-4">
                            <button 
                                className="btn btn-primary btn-lg" 
                                onClick={handleGuardarActivo}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Guardando...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-save me-2"></i> Guardar Activo
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}